import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-background-50 px-4 text-center">
      <span className="w-20 h-20 flex items-center justify-center rounded-full bg-background-200/70 text-foreground-300 mb-6">
        <i className="ri-emotion-sad-line text-4xl"></i>
      </span>
      <h1 className="font-heading text-4xl md:text-5xl font-bold text-foreground-900 mb-3">404</h1>
      <p className="text-base text-foreground-500 mb-8">抱歉，您访问的页面不存在</p>
      <Link
        to="/"
        className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 rounded-full text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
      >
        <i className="ri-home-line"></i> 返回首页
      </Link>
    </div>
  );
}